module.exports = __webpack_public_path__ + "img/malfunction.ebed5f24.png";